import { numberFormatter } from '../../../../../../utils/formatters';
/**
 * Gets label text for lambda value
 *
 * @param lambda - Lambda value
 * @returns Formatted text
 */
export const getLambdaText = (lambda) => `λ: ${numberFormatter({ value: lambda })}`;
